import { ContentRoute,RouteSlotInput  } from '@caritas/ui';

import { usePetitionResultQuery } from '../../../generated/queries/react-queries';

export function mapPetitionTool(
  input: BlockPetitionFragment,
): RouteSlotInput<typeof ContentRoute, 'body', 'petition'> {
  // @todo: use persisted queries.
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const petitionResult = usePetitionResultQuery({
    webformId: input.webformId,
  });
  return {
    key: 'petition',
    input: () => [
      {
        number: !petitionResult.isLoading && petitionResult.data?.petitionResult ? petitionResult.data?.petitionResult.confirmedSubmissions.toString() : '0',
        description: input.description || '',
      },
      200,
    ],
  };
};
